var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretRightBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 200 352",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 176.257C200.004 179.442 199.379 182.597 198.159 185.541C196.94 188.484 195.151 191.157 192.896 193.407L41.3867 344.916C36.8363 349.455 30.6699 352.004 24.2421 352C17.8143 351.996 11.6507 349.442 7.10524 344.897C2.55981 340.352 0.00427749 334.189 5.3649e-06 327.761C-0.00426676 321.333 2.54307 315.166 7.08246 310.615L141.439 176.257L7.08246 41.8979C2.54307 37.3469 -0.00426676 31.1803 5.3649e-06 24.7524C0.00427749 18.3246 2.55981 12.1613 7.10524 7.61639C11.6507 3.07149 17.8143 0.516671 24.2421 0.513149C30.6699 0.509627 36.8363 3.05769 41.3867 7.59761L192.896 159.106C195.151 161.356 196.94 164.029 198.159 166.972C199.379 169.916 200.004 173.071 200 176.257Z",
    fill: "#1A405F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretRightBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CaretRightBlue.55072b68.svg";
export { ForwardRef as ReactComponent };